export default function ConfirmOrderModal({ isOpen, onConfirm, onDecline, theme, preparedOrder }) {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
    };

    const handleDecline = () => {
        onDecline();
    };

    const styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
        },
        modal: {
            backgroundColor: theme.cardBg || "#1f1f1f",
            opacity: 1,
            borderRadius: "16px",
            padding: "32px",
            width: "90%",
            maxWidth: "420px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
        },
        header: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "24px",
        },
        title: {
            fontSize: "18px",
            fontWeight: "600",
            color: theme.text,
            opacity: 0.9,
        },
        content: {
            marginBottom: "20px",
            color: theme.text,
            fontSize: "15px",
            lineHeight: "1.6",
            whiteSpace: "pre-wrap",
        },
        buttonRow: {
            display: "flex",
            gap: "12px",
            justifyContent: "center",
        },
        button: {
            padding: "12px 28px",
            borderRadius: "10px",
            border: "none",
            fontSize: "15px",
            fontWeight: "500",
            cursor: "pointer",
            transition: "all 0.2s",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        },
        confirmBtn: {
            backgroundColor: theme.buttonBg,
            color: theme.buttonText,
        },
        declineBtn: {
            backgroundColor: "#ff4444",
            color: "white",
        },
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <div style={styles.title}>Підтвердити замовлення?</div>
                </div>

                <div style={styles.content}>
                    {preparedOrder}
                </div>

                <div style={styles.buttonRow}>
                    <button
                        style={{ ...styles.button, ...styles.declineBtn }}
                        onClick={handleDecline}
                    >
                        Відхилити
                    </button>
                    <button
                        style={{ ...styles.button, ...styles.confirmBtn }}
                        onClick={handleConfirm}
                    >
                        Підтвердити
                    </button>
                </div>
            </div>
        </div>
    );
}
